import { render, staticRenderFns } from "./Beta.vue?vue&type=template&id=26dc4a42"
import script from "./Beta.vue?vue&type=script&lang=js"
export * from "./Beta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports